module.exports = __webpack_public_path__ + "img/c00_buildingtechpickersgloves_Normal_ua.d7a1f9c3.webp";